import React, { Component, PropTypes } from 'react';

import { capitalizeFirstLetter } from '../../../../util/empty-helpers.js';
import FetchJSON from '../../../../util/fetch-json';
import { desktopBreakpoint } from '../../../../constants/breakpoints.js';
import { KEYS } from '../../../../constants/keys.js';

export default class SiteSearch extends Component {
  constructor(props) {
    super(props);

    this.inputRef = null;
    this.inactivityTimer = null;
    this.timeout = this.props.inactivityTimeout
      ? parseInt(this.props.inactivityTimeout, 10) * 1000
      : 10000;
  
    const isMobile = window.innerWidth <= desktopBreakpoint;
    this.state = {
      searchValue: "",
      results: [],
      searchOpen: false,
      isMobile,
    };
  }

  selectOption(e, index) {
    e.preventDefault();
    if (index >= 0) {
      window.location.href = this.state.results[index].Url;
      return;
    }
  }

  handleChange(event) {
    const searchValue = event.target.value;
    const url = "/api/SiteSearch/Search?query=" + searchValue;

    if (searchValue === "") {
      this.setState({ results: [], searchValue });
    } else {
      this.setState({ isLoading: true, searchValue });

      FetchJSON.fetch(url, "GET").then((results) => {
        if (results) {
          // Set values to search
          let valueLowerCase = searchValue.toLowerCase();
          let valueUpper = capitalizeFirstLetter(valueLowerCase);

          // Set up regex for global search
          let regex = new RegExp(valueLowerCase, "g");
          let regexUpper = new RegExp(valueUpper, "g");

          // Loop through and replace instances
          for (let i = 0; i < results.length; i++) {
            let replaceName = results[i].Title;
            replaceName = replaceName.replace(
              regex,
              '<span class="highlight">' + valueLowerCase + "</span>"
            );
            replaceName = replaceName.replace(
              regexUpper,
              '<span class="highlight">' + valueUpper + "</span>"
            );
            results[i].Title = replaceName;
          }
          if (searchValue === this.state.searchValue) {
            this.setState({ results });
          }
        }
      });
    }
  }

  getTypeClass(type) {
    switch (type) {
      case "Hotel": {
        return "SiteSearch_item-hotel";
      }
      case "MultiCenterPage": {
        return "SiteSearch_item-multi";
      }
      case "Point of Interest": {
        return "SiteSearch_item-excursion";
      }
      default: {
        return "SiteSearch_item-location";
      }
    }
  }

  handleCloseSearch = () => {
    this.toggleNav(null, false);
    this.setState({
      searchValue: "",
    });
  };

  toggleNav(e, hasSearched) {
    if (this.state.searchOpen && !this.state.searchValue && hasSearched) return;
    if (e) e.preventDefault();
    if ((this.state.isMobile || this.state.searchOpen) && hasSearched) {
      window.location.href = `/search?query=${this.state.searchValue}`;
      return;
    }
    if (this.inputRef) {
      if (!this.state.searchOpen) {
        this.inputRef.focus();
        this.inactivityTimer = window.setTimeout(this.handleCloseSearch, this.timeout);
      } else {
        window.clearTimeout(this.inactivityTimer);
        this.inputRef.blur();
      }
    }
    this.setState({
      searchOpen: !this.state.searchOpen,
    });
  }

  handleKeyDown(event) {
    // Reset inactivity timer
    window.clearTimeout(this.inactivityTimer);
    this.inactivityTimer = window.setTimeout(this.handleCloseSearch, this.timeout);
    // Handle specific keypresses
    switch (event.keyCode) {
      case KEYS.ENTER: {
        this.toggleNav(null, true);
        break;
      }
      case KEYS.ESC: {
        this.toggleNav(null, false);
      }
      default: {
        return;
      }
    }
  }

  setRef = (ref) => {
    if (this.inputRef) return;
    this.inputRef = ref;
  };

  render() {
    const { contactLink, contactText } = this.props;
    return (
      <div
        className={`SiteSearch_container  ${
          this.state.searchOpen ? "SiteSearch-open" : ""
        }`}
      >
        <div className="SiteSearch-mobileSearch">
          <div className="SiteSearch_inputContainer">
            <input
              className="SiteSearch_input"
              type="text"
              name="query"
              placeholder="Search this site..."
              onChange={(event) => this.handleChange(event)}
              autoComplete="off"
            />
          </div>
          <button
            type="submit"
            className="SiteSearch_mobileSubmit"
            onClick={(e) => this.toggleNav(e, true)}
          >
            <i className="SiteSearch_icon fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
        <div className="SiteSearch_form" role="search">
          <button
            type="submit"
            className="SiteSearch_submit"
            onClick={(e) => this.toggleNav(e, true)}
          >
            <i className="SiteSearch_icon fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
        {contactLink && contactText && (
          <a href={contactLink} className="SiteSearch_contact">
            {contactText}
          </a>
        )}
        <div className="SiteSearch-fullWidth">
          <div
            className="SiteSearch_close"
            onClick={(e) => this.toggleNav(e, false)}
          >
            <i className="SiteSearch_icon fa fa-times" aria-hidden="true"></i>
          </div>
          <div className="SiteSearch_inputContainer">
            <input
              ref={(ref) => this.setRef(ref)}
              className="SiteSearch_input"
              type="text"
              name="query"
              placeholder="Search this site..."
              onChange={(event) => this.handleChange(event)}
              onKeyDown={(event) => this.handleKeyDown(event)}
              autoComplete="off"
            />
          </div>
        </div>
        {(this.state.isMobile || this.state.searchOpen) &&
          this.state.results.length > 0 && (
            <div className="SiteSearch_results">
              {this.state.results.map((result, index) => {
                let typeClass = this.getTypeClass(result.Template);
                return (
                  <div
                    key={index}
                    className={"SiteSearch_item " + typeClass}
                    dangerouslySetInnerHTML={{ __html: result.Title }}
                    onClick={(e) => this.selectOption(e, index)}
                  ></div>
                );
              })}
            </div>
          )}
      </div>
    );
  }
}
